import React from 'react'
import Lottie from 'react-lottie'

import animation39 from '../../images/lotties/animation39.json'

const animationOptions = {
  loop: true,
  autoplay: true,
  animationData: animation39,
  assetsPath: 'https://dev-interaktiv-mf.tagesanzeiger.ch/2023/schaad-kiribati-msf/animation39/',
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
}

function Animation9(props) {
  return (
    <div
      className={`picture ${props.className ? props.className : ''}`}
      style={props.style}
    >
      {
        <Lottie
           options={animationOptions}
           isClickToPauseDisabled={true}
        />
      }
      {props.children && <div className='inner'>{props.children}</div>}
    </div>
  )
}

export default Animation9
